'use client';

import classnames from 'classnames';
import { useAtomValue } from 'jotai';
import React from 'react';
import { IImage } from '@sapientpro/sapientpro-data-models';
import { theme, Theme } from '../store/theme';
import Img from './Img';

import styles from './SocialLink.module.scss';

interface FooterSocialLinkProps {
  icon?: string,
  link: string,
  id?: string,
  className?: string,
  onClick?: () => void,
  customIcon?: IImage;
}

const SocialLink = ({
  icon, id, link, className, onClick, customIcon,
}: FooterSocialLinkProps) => {
  const appTheme = useAtomValue<Theme>(theme);

  return (
    <div className={classnames(styles.social, className)}>
      <a
        href={link}
        target='_blank'
        className={styles.social__link}
        rel='noreferrer'
        onClick={() => onClick?.()}
      >
        <Img
          src={`/media/socials/social-particles-${appTheme}.webp`}
          alt='particles'
          className={styles.social__link__particles}
        />
        {customIcon ? (
          <Img
            src={customIcon?.url}
            alt={customIcon?.alternativeText || 'social icon'}
            width={24}
            height={24}
          />
        ) : (
          <svg className={styles.icon}>
            <use
              xlinkHref={`${icon}#${id}`}
              href={`${icon}#${id}`}
            />
          </svg>
        )}
      </a>
    </div>
  );
};

export default SocialLink;
